// flow weak

import React, {
    PureComponent
  }                             from 'react';
  import PropTypes              from 'prop-types';
  import AnimatedView           from '../../../../components';
  import styles                 from './style'
  import {
    defaultOptions,
    checkStatus,
    parseJSON,
    getLocationOrigin
  }                     from '../../../../services/fetchTools';
  import { withRouter } from 'react-router';
  import Dialog from 'material-ui/Dialog';
  import FlatButton from 'material-ui/FlatButton';
  import RaisedButton from 'material-ui/RaisedButton';
  import { Multiselect } from 'react-widgets';
  import TimePicker from 'react-times';
  import 'react-times/css/classic/default.css';
  
  
  class DaAllocation extends PureComponent {
    static propTypes = {
      actions: PropTypes.shape({
        enterPage: PropTypes.func,
        leavePage: PropTypes.func,
      })
    };
  
    constructor(props) {
      super(props);
      this.state = { 
        desk_result:[],
        desk_list: [],
        details:{
          desk_associate:'',
          venue:this.props.venue ? this.props.venue : '',
          start_time:'00:00',
          end_time:'00:00',
          day_of_week:[]
        },
        success:false,
        message:''
      };
      this.handleChange = this.handleChange.bind(this)
      this.handleSubmit = this.handleSubmit.bind(this)
      this.onStartTimeChange = this.onStartTimeChange.bind(this)
      this.onEndTimeChange = this.onEndTimeChange.bind(this)
      this.handleVenueChange = this.handleVenueChange.bind(this)
    }
  
    componentDidMount() {
        this.getDetails();
    }  

    getDetails(){
      const url = `${getLocationOrigin()}/cm/get_details_for_da_allocation/`;
     const options = {...defaultOptions};

    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => {
            if(data.success){
              var new_value =  Object.assign({}, this.state.details);
              if(!this.state.details.venue){
                new_value['venue'] = data.result[0].id
                if(data.result[0].desk_associates.length > 0){
                  new_value['desk_associate'] = data.result[0].desk_associates[0].id
                }
                this.setState({success:data.success,desk_result:data.result,details:new_value,desk_list:data.result[0].desk_associates})
              }
              else{
                const desk_data = data.result.find(venue=>venue.id == this.state.details.venue).desk_associates
                if(desk_data.length > 0){
                  new_value['desk_associate'] = desk_data[0].id
                }
                this.setState({success:data.success,desk_result:data.result,details:new_value,desk_list:desk_data})
              }
              
            }
            else{
              this.setState({success:data.success,message:data.message})
            }
           // alert("fix");
       }).catch(error => error);
    }

    postUpdateBooking(details,props) {
        console.log(details)
        const url = `${getLocationOrigin()}/buddy/allocate_da/`;
        const options = {...defaultOptions};
        options['method'] = 'post';
        options['headers'] = {'content-type': 'application/json'}
        options['body'] = JSON.stringify({
                                          'desk_details': details
                                              });
        console.log('Going to fetch');
        return fetch(url, options)
          .then(checkStatus)
          .then(parseJSON)
          .then(response=>{  
            console.log('response',response)
            alert(response.message)
            props.history.goBack();
          })
          .catch(error => {
            console.log(error);
            alert(error.message);
          });
      }

    handleChange(event) {
        const name = event.target.name;
        const target = event.target
        const value = target.value
        console.log(name,value)
        var new_value =  Object.assign({}, this.state.details);
        new_value[name] = value
        this.setState({details: new_value});
        // this.getAmount(this.state.equipment_details)
    }

    handleSubmit(event) {
        console.log('handle')
        event.preventDefault();
        console.log('Submit');
        if(this.state.details.start_time == '00:00' || this.state.details.end_time == '00:00'){
          alert('Please ensure start/end time is correct')
        }
        else if(this.state.details.day_of_week.length == 0){
          alert('Please select days')
        }
        else{
        this.postUpdateBooking(this.state.details,this.props)
        }
      }

    onStartTimeChange(options) {
    console.log('options',options)
    var new_value =  Object.assign({}, this.state.details);
    new_value['start_time'] = options
    this.setState({details: new_value});
    }

    onEndTimeChange(options) {
    console.log('options',options)
    var new_value =  Object.assign({}, this.state.details);
    new_value['end_time'] = options
    this.setState({details: new_value});
    }

    handleDaysCheckbox = (e, s) => {
      var new_value =  Object.assign({}, this.state.details);
      const dayscheckedBoxes = [...this.state.details.day_of_week];
      if(e.target.checked) {
          dayscheckedBoxes.push(s)
      } else {
          const index = dayscheckedBoxes.findIndex((ch) => ch.id === s.id);
          dayscheckedBoxes.splice(index, 1);
      }
      new_value['day_of_week'] = dayscheckedBoxes
      this.setState({details:new_value});
      console.log('day_of_week',dayscheckedBoxes)
    }

    handleVenueChange(event){
      var data = this.state.desk_result
      var val = event.target.value
      var desk_data = data.find(da=>da.id==val)
      var new_value =  Object.assign({}, this.state.details);
      new_value['venue'] = val
      if(desk_data.desk_associates.length > 0){
        new_value['desk_associate'] = desk_data.desk_associates[0].id
      }
      this.setState({details:new_value,desk_list:desk_data.desk_associates})
    }
  

    render() {
      console.log('amount')
      console.log(this.state.desk_result);
      console.log(this.state.details)

      var days = [{"name":"Mon","id":0},{"name":"Tue","id":1},{"name":"Wed","id":2},{"name":"Thu","id":3},{"name":"Fri","id":4},{"name":"Sat","id":5},{"name":"Sun","id":6}]

      return(
        <div style={styles.container}> 

          <div className="row col-md-9 table-bordered" style={styles.table}>
            <div style={styles.main_header} className="col-md-12 label_blue_1">
              <h3 style={{textAlign:'center'}}> DA Allocation</h3>
            </div>
              <form  className="validated-form form-horizontal">

              <div style={{display:'flex',flexDirection:'row',padding: '1%'}} className="col-md-12">
                <div style={styles.item_header} className="col-md-6">
                  Venue
                </div>
               <select name="venue" className="col-md-6" style={styles.item_body} value={this.state.details.venue}
                 onChange={this.handleVenueChange} disabled={this.props.venue ? 'disabled' : ''}>
                  {
                     this.state.desk_result.map((venue,index)=>(
                       <option key={venue.id} value={venue.id}>{venue.name}</option>
                      ))
                   }
               </select>
              </div>

              <div style={{display:'flex',flexDirection:'row',padding: '1%'}} className="col-md-12">
                <div style={styles.item_header} className="col-md-6">
                  Desk Associate
                </div>
               <select name="desk_associate" className="col-md-6" style={styles.item_body}
                 onChange={this.handleChange}>
                  { this.state.desk_list.length > 0 ?
                     this.state.desk_list.map((desk,index)=>(
                       <option key={desk.id} value={desk.id}>{desk.name} : {desk.mobile_no} </option>
                      ))
                    :
                    <option> ----- </option>
                  }
               </select>
              </div>

              <div style={styles.items,{display:'flex',flexDirection:'row'}} className="col-md-12">
                  <div style={styles.item_header} className="col-md-6">
                      <span className='col-md-3' style={{display:'contents',marginBottom:'1%'}}>Start Time </span>
                      <div style={{width:'90%'}}>
                          <TimePicker className="col-md-3"  theme="classic" time={this.state.details.start_time} name='start_time' onTimeChange={this.onStartTimeChange} />
                      </div>
                  </div>
                  <div style={styles.item_header} className="col-md-6">
                      <span className='col-md-3' style={{display:'contents',marginBottom:'1%'}}>End Time </span>
                      <div style={{width:'90%'}}>
                          <TimePicker className="col-md-3" theme="classic" time={this.state.details.end_time} name='end_time' onTimeChange={this.onEndTimeChange} />
                      </div>
                  </div>
              </div>

              
            <div style={styles.items} className="col-md-12">
              <div style={styles.court_list}>
                  {
                    days.map((x, index) => (
                      <label>
                      <input type="checkbox"
                      checked={this.state.details.day_of_week.find((ch) => ch.id === x.id)}
                      onChange={(e) => this.handleDaysCheckbox(e, x)}
                    />
                    <div style={{paddingLeft: '3%', paddingRight:'3%',fontSize:12}} key={x.id} value={x.id}>{x.name}</div>
                    </label>
                    ))
                  }
              </div>
            </div>
             
              <div style={{display:'flex', flexDirection:'row', padding:'1%', marginLeft:'10px'}}>
                <div style={styles.button_submit} className="col-md-12">
                  <input className="button1" type="submit" value="Submit" onClick={this.handleSubmit} />
                </div>
              </div>
                
            </form>
            
          </div>
        </div>
      );
    }
  }
  
  export default DaAllocation;
  


// WEBPACK FOOTER //
// ./src/app/views/partner/crud/daAllocation/index.js